<template>
  <div>
    <div
      :class="[borderColor, orderCanceled ? 'bg-light-gray-500' : 'bg-white']"
      class="order-card"
    >
      <div class="flex items-center justify-between mb-3">
        <div class="flex gap-2 items-center">
          <w-date-time-display
            :date-time="item.receive_times[0]"
            hide-start-date
            text-class="font-medium text-black text-lg" />
          <t-dropdown v-if="item.receive_times.length > 1">
            <div
              slot="trigger"
              slot-scope="{
                mousedownHandler,
                focusHandler,
                blurHandler,
                keydownHandler
              }"
            >
              <w-button
                variant="icon"
                @blur="blurHandler"
                @focus="focusHandler"
                @keydown="keydownHandler"
                @mousedown="mousedownHandler"
              >
                <i class="cursor-pointer icon-chevron-down w-4" />
              </w-button>
            </div>

            <template>
              <div class="p-4">
                <div
                  v-for="(receiveTime, index) in item.receive_times"
                  :key="`receiveTime-${index}`"
                >
                  <w-date-time-display :date-time="receiveTime" text-class="text-black text-sm" />
                </div>
              </div>
            </template>
          </t-dropdown>
        </div>
        <slot name="header" />
      </div>
      <div class="border-gray-50 border-t flex-col gap-y-2 pt-3 w-full">
        <span class="break-all font-medium">{{ item.name }}</span>
        <div
          v-for="order in memberOrders"
          :key="order.id"
          class="mt-2"
        >
          <div class="flex items-baseline justify-between">
            <div class="flex gap-2 items-baseline">
              <i class="icon-food mr-2" />
              <div class="flex flex-wrap gap-x-2 items-center">
                <w-date-time-display :dateTime="order.receive_time" />
                <template v-if="isCancelledOrder(order)">
                  <span class="text-gray-500 text-sm">
                    (取消時間：{{ getDateTimeText(order.canceled_at) }})
                  </span>
                </template>
                <template v-else>
                  <span class="text-gray-500 text-sm">
                    (訂購時間：{{ getDateTimeText(order.created_at) }})
                  </span>
                </template>
              </div>
            </div>
            <span
              v-if="isCancelledOrder(order)"
              class="text-red-700 text-sm whitespace-nowrap"
              >
                訂單已取消
            </span>
            <span v-else class="font-medium">{{ getOrderTotal(order) }}</span>
          </div>
          <div class="flex justify-between mt-2">
            <div class="flex flex-col gap-y-2">
              <div
                v-for="(entree, index) in getOrderContents(order)"
                :key="`${entree.entree_index}_${index}`"
                :class="{ 'line-through': isCancelledOrder(order) }"
                class="flex gap-1 text-sm"
              >
                <span class="min-w-[32px]">{{ entree.quantity }}x</span>
                <div class="flex flex-col gap-1">
                  <div class="flex gap-1">
                    <span class="sm:max-w-[100px] max-w-[280px]">{{ entree.entree_name }}</span>
                    <span>{{ entree.entree_price | commaFormat | priceFormat }}</span>
                  </div>
                  <span
                    v-if="getOptionItems(entree)"
                    class="sm:max-w-[100px] max-w-[280px] text-xs"
                  >
                    {{ getOptionItems(entree) }}
                  </span>
                  <span
                    v-if="entree.note"
                    class="sm:max-w-[100px] max-w-[280px] text-xs"
                  >
                    備註：{{ entree.note }}
                  </span>
                </div>
              </div>
            </div>
            <w-button
              v-if="order.status !== RECEIVE_STATUS.CANCELED && !isEnded && showCancelButton"
              class="order-cancel-btn"
              @click="cancelOrder(order, item.name)"
            >
              <span class="text-xs">取消訂單</span>
            </w-button>
          </div>
        </div>
        <template v-if="showCollapsed">
          <div
            v-if="inProgress &&
              !isCollapsed &&
              showEndTimeString"
            class="flex justify-center mt-2 text-gray-500 text-sm"
          >
            {{ endTimeString }}
          </div>
          <div class="flex gap-4 items-center pt-1">
            <div class="border-t border-gray-50 flex-grow" />
            <button class="text-primary-500" @click="isCollapsed = !isCollapsed">
              {{ isCollapsed ? '展開更多' : '收合' }}
            </button>
            <div class="border-t border-gray-50 flex-grow" />
          </div>
        </template>
        <template v-else>
          <div
            v-if="!isEnded && showEndTimeString"
            :class="{'text-center': item.joined}"
            class="mt-2"
          >
            <span class="text-gray-500 text-sm">
              {{ inScheduled ? startTimeString : endTimeString }}
            </span>
          </div>
        </template>
      </div>
    </div>
    <cancel-order
      v-if="showCancel"
      v-model="showCancel"
      :order-name="cancelOrderName"
      :order-uuid="cancelOrderData.uuid"
      @success="onCancelSuccess"
      @close="showCancel = false" />
  </div>
</template>

<script>
import OrderCard from './OrderCard';

export default OrderCard;
</script>

<style lang="scss" scoped>
@import 'OrderCard';
</style>
